import {uniq} from 'lodash'
import {OrderProvider} from 'providers/OrderProvider'
import {useMemo} from 'react'

export const useOrderOfferCombinations = () => {
  const order = OrderProvider.useOrder()
  return useMemo(() => {
    return uniq(
      (order.offerCombinations || []).map((offerCombination) => {
        return offerCombination.productId
      })
    )
  }, [order])
}
